<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
  <!-- Client Details Card -->
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Client Details</h3>
    </div>
    <div class="card-body pt-2 text-sm">
      <div *ngFor="let c of dataClientlist" class="space-y-2">
        <div class="flex justify-between">
          <span class="font-medium">Rep Name:</span>
          <span>{{ c.firstNameRep }} {{ c.lastNameRep }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Rep Code:</span>
          <span>{{ c.repCode }} : {{ c.repTitle }} : {{ c.repType }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Rep Branch:</span>
          <span>{{ c.branchNumber }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Client Name:</span>
          <span>{{ c.firstName }} {{ c.lastName }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Sponsor:</span>
          <span>{{ c.sponsorName }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Transaction Type:</span>
          <span>{{ c.transactionTypeDesc }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Status:</span>
          <span>{{ c.statusTypeDesc }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Product:</span>
          <span>{{ c.productName }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Mutual Fund Class:</span>
          <span>{{ c.mutualFundClass }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Amount:</span>
          <span>{{ c.amount | currency }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Account Number:</span>
          <span>{{ c.accountNumber }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Check Number:</span>
          <span>{{ c.checkNumber }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Date Received:</span>
          <span>{{ c.dateReceived | date : 'MM/dd/yyyy' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Mail Log:</span>
          <span>{{ c.mailLog }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Mail To:</span>
          <span>{{ c.mailTo }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Mail Date:</span>
          <span>{{ c.mailDate | date : 'MM/dd/yyyy' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Document Description:</span>
          <span>{{ c.documentDescription }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Tracking Number:</span>
          <span>{{ c.trackingNumber }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">New Account Form:</span>
          <span>{{ c.newAccountForm }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">New Account Form Date:</span>
          <span>{{ c.dateOfNewAccountForm | date : 'MM/dd/yyyy' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Copy of Drivers License:</span>
          <span>{{ c.copyOfDl }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Investment Objective:</span>
          <span>{{ c.descriptionObj }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Investment Horizon:</span>
          <span>{{ c.lengthOfTime }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">VA Acknowledgement Form:</span>
          <span>{{ c.vadisclosureForm ? 'Yes' : 'No' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Entered By Rep:</span>
          <span>{{ c.enteredByRep ? 'True' : 'False' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Approved By:</span>
          <span>{{ c.approvedBy }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">VA Good Order Date:</span>
          <span>{{ c.vagoodOrderDate | date : 'MM/dd/yyyy' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Date Approved:</span>
          <span>{{ c.approvedByDate | date : 'MM/dd/yyyy' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Date Client Signed:</span>
          <span>{{ c.dateSigned | date : 'MM/dd/yyyy' }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Modified By:</span>
          <span>{{ c.modifiedBy }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium">Date Modified:</span>
          <span>{{ c.modifiedDate | date : 'MM/dd/yyyy' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Comments Card -->
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Comments</h3>
    </div>
    <div class="card-body text-sm">
      <div *ngFor="let c of dataComments" class="space-y-2">
        <div class="text-muted">
          Modified by: {{ c.modifiedBy }}<br />
          Date Modified: {{ c.modifiedDate | date : 'MM/dd/yyyy' }}
        </div>
        <textarea
          [rows]="chooserows"
          readonly
          placeholder="No comments have been entered"
          cols="100"
          kendoTextArea
          class="w-full border p-2 rounded"
        >{{ c.comment }}</textarea>
      </div>
    </div>
  </div>

  <!-- Alerts Card -->
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Alerts</h3>
    </div>
    <div class="card-body">
      <kendo-grid
        [data]="view"
        [height]="210"
        [pageable]="false"
        [resizable]="true"
        [filterable]="false"
        [sortable]="true"
        [navigable]="false"
      >
        <kendo-grid-column field="attempt" title="ID" [width]="130"></kendo-grid-column>
        <kendo-grid-column field="alertText" title="Alert" [width]="130"></kendo-grid-column>
        <kendo-grid-column field="dateTimeSent" title="Date Sent" [width]="130" format="{0:d}">
          <ng-template kendoGridCellTemplate let-column>
            {{ column.dateTimeSent | date : 'MM/dd/yyyy, h:mm:ss a' }}
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>

<!-- Close Button -->
<div class="mt-6 flex justify-end">
  <button 
    class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md shadow-sm"
    (click)="closeDialog()">
    Close
  </button>
</div>